export { default } from './CbreLogo';
export * from './CbreLogo';
